import { Func } from 'interfaces/func';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import SurveyStatisticsQuestionAnswer from 'models/statistics/survey/questions/answer';
import SurveyStatisticsQuestion from 'models/statistics/survey/questions/question';
import SurveyQuestion from 'models/survey/question';
import SurveyStatisticsQuestionChoice from './questionChoice';

const defaultSortFunc = () => 1;

interface SurveyStatisticsQuestionSectionConfig<T extends SurveyStatisticsQuestionAnswer> {
    title?: SubscribableOrNullableValue<string>
    hidden?: SubscribableOrNullableValue<boolean>
    scoremode?: SubscribableOrNullableValue<boolean>

    surveyQuestion: SubscribableOrNullableValue<SurveyQuestion>
    surveyStatQuestion: SubscribableOrNullableValue<SurveyStatisticsQuestion<T>>

    value: Func<StringMap<number>, [answers: Array<T>]>
    rank: Func<StringMap<number>, [answers: Array<T>]>
    sortBy?: Func<string | number, [answer: T]>
}

export default class SurveyStatisticsQuestionSection<T extends SurveyStatisticsQuestionAnswer = SurveyStatisticsQuestionAnswer> {
    title: Subscribable<string | undefined>
    choices: Subscribable<Array<SurveyStatisticsQuestionChoice>>

    isHidden: Subscribable<boolean>

    constructor(config: SurveyStatisticsQuestionSectionConfig<T>) {
        const surveyQuestion = ko.flattenComputed(config.surveyQuestion);
        const surveyStatQuestion = ko.flattenComputed(config.surveyStatQuestion);

        const choices = surveyQuestion.pluck(q => q.choices, []);
        const blankOptions = surveyQuestion.pluck(q => q.blankOptions, []);

        const answers = surveyStatQuestion.pluck(q => q.answers, []);
        const sortedAnswers = answers.sortBy(a => sortByFunc(a));

        const sortByFunc = config.sortBy ?? defaultSortFunc;
        const buildValuesFunc = config.value;
        const buildRanksFunc = config.rank;

        const values = ko.pureComputed(() => buildValuesFunc(sortedAnswers()));
        const ranks = ko.pureComputed(() => buildRanksFunc(sortedAnswers()));

        this.title = ko.flattenComputed(config.title);        

        this.choices = sortedAnswers.map(answer => {
            const choice = choices.find(ch => ch.choiceId() == answer.questionChoiceId());
            const blank = blankOptions.find(ch => ch.optionId() == answer.questionChoiceId());
            const value = ko.pureComputed(() => values()[answer.questionChoiceId()].toString());
            const rank = ko.pureComputed(() => ranks()[answer.questionChoiceId()].toFixed(1));
            
            const cTitle = ko.pureComputed(() => choice()?.text() ?? blank()?.text() ?? '');
            
            return new SurveyStatisticsQuestionChoice({
                questionChoiceId: answer.questionChoiceId,
                title: cTitle.pluck(t => t),//choice.pluck(ch => ch.text()) ?? blank.pluck(b => b.text()) ?? '',
                value: value,
                rank: rank,
                scoremode: config.scoremode
            });
        });

        this.isHidden = ko.flattenComputed(config.hidden, false);
    }
}